<script lang="ts">
  export let steps: Array<string> = [];
  export let currentStep: number = 0;
  export let isCompact: boolean = true;
</script>

<ul class="wk-stepthrough wk-is-compact" class:wk-stepthrough-small={isCompact}>
  {#each steps as step, i}
    {#if i === currentStep}
      <li class="wk-stepthrough-step wk-is-active" aria-current="step" data-state="{i}">
        <span class="wk-stepthrough-icon wk-stepthrough-icon-active">
          <span class="wk-stepthrough-icon wk-stepthrough-icon-small"></span>
        </span>
        {#if !isCompact}
        <span class="wk-stepthrough-label">{step}</span>
        {/if}
      </li>
    {:else}
      <li class="wk-stepthrough-step" data-state="{i}">
        <span class="wk-stepthrough-icon"></span>
        {#if !isCompact}
        <span class="wk-stepthrough-label">{step}</span>
        {/if}
      </li>
    {/if}
  {/each}
</ul>

<style lang="scss">
  .wk-stepthrough-small {
    padding: .5rem !important;
    min-width: 10rem;
  }

</style>
